package com.schoolconnect.app.feature.home

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.expandHorizontally
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.shrinkHorizontally
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import com.schoolconnect.app.designsystem.AppDropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.PlainTooltip
import androidx.compose.material3.Text
import androidx.compose.material3.TooltipBox
import androidx.compose.material3.TooltipAnchorPosition
import androidx.compose.material3.TooltipDefaults
import androidx.compose.material3.rememberTooltipState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.DpOffset
import androidx.compose.foundation.layout.widthIn
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppPurpleSoft
import com.schoolconnect.app.designsystem.AppPurpleText
import com.schoolconnect.app.designsystem.AppSecondaryBorder
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AdminSummaryMetrics
import com.schoolconnect.app.designsystem.AppWarning
import com.schoolconnect.app.designsystem.AppWarningSoft
import com.schoolconnect.app.designsystem.AppButton
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.datasource.network.response.DashboardAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.DashboardSchoolsAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.DashboardStatisticsCountMetrics
import com.schoolconnect.app.datasource.network.response.DashboardStatisticsResponse
import com.schoolconnect.app.datasource.network.response.EventsNoticesAnalyticsResponse
import com.schoolconnect.app.datasource.network.response.RecentActivitiesResponse
import com.schoolconnect.app.datasource.network.response.RecentActivitySummary
import com.schoolconnect.app.datasource.network.response.SystemHealthResponse
import com.schoolconnect.app.datasource.network.response.SchoolStatisticsResponse
import com.schoolconnect.app.datasource.network.response.RecentNoticeSummary
import com.schoolconnect.app.datasource.network.response.UpcomingEventSummary
import com.schoolconnect.app.domain.SchoolKeys
import com.schoolconnect.app.feature.rolepicker.RolePickerOption
import com.schoolconnect.app.feature.rolepicker.RolePickerUiState
import com.schoolconnect.app.theme.interSemiBold
import com.schoolconnect.app.theme.interBold
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.academic_years
import ischoolconnect.sharedui.generated.resources.activity_calendar
import ischoolconnect.sharedui.generated.resources.activity_new_school
import ischoolconnect.sharedui.generated.resources.activity_payment
import ischoolconnect.sharedui.generated.resources.activity_ticket
import ischoolconnect.sharedui.generated.resources.activity_user
import ischoolconnect.sharedui.generated.resources.arrow_left
import ischoolconnect.sharedui.generated.resources.arrow_right
import ischoolconnect.sharedui.generated.resources.audit_logs
import ischoolconnect.sharedui.generated.resources.bell
import ischoolconnect.sharedui.generated.resources.blood_drop
import ischoolconnect.sharedui.generated.resources.building
import ischoolconnect.sharedui.generated.resources.book
import ischoolconnect.sharedui.generated.resources.open_book
import ischoolconnect.sharedui.generated.resources.building_school
import ischoolconnect.sharedui.generated.resources.school_config
import ischoolconnect.sharedui.generated.resources.broadcasts
import ischoolconnect.sharedui.generated.resources.brand_header_proper
import ischoolconnect.sharedui.generated.resources.cloud_upload
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.clock
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.chevron_up
import ischoolconnect.sharedui.generated.resources.chevron_right
import ischoolconnect.sharedui.generated.resources.chevron_left
import ischoolconnect.sharedui.generated.resources.config
import ischoolconnect.sharedui.generated.resources.document
import ischoolconnect.sharedui.generated.resources.dashboard
import ischoolconnect.sharedui.generated.resources.edit
import ischoolconnect.sharedui.generated.resources.folder
import ischoolconnect.sharedui.generated.resources.health_backup
import ischoolconnect.sharedui.generated.resources.health_chart
import ischoolconnect.sharedui.generated.resources.health_database
import ischoolconnect.sharedui.generated.resources.health_email
import ischoolconnect.sharedui.generated.resources.health_server
import ischoolconnect.sharedui.generated.resources.health_sms
import ischoolconnect.sharedui.generated.resources.graduation_cap
import ischoolconnect.sharedui.generated.resources.help_desk
import ischoolconnect.sharedui.generated.resources.home
import ischoolconnect.sharedui.generated.resources.it_users
import ischoolconnect.sharedui.generated.resources.ic_rotate_right
import ischoolconnect.sharedui.generated.resources.mail
import ischoolconnect.sharedui.generated.resources.logout
import ischoolconnect.sharedui.generated.resources.megaphone
import ischoolconnect.sharedui.generated.resources.notifications
import ischoolconnect.sharedui.generated.resources.payments
import ischoolconnect.sharedui.generated.resources.plans
import ischoolconnect.sharedui.generated.resources.phone
import ischoolconnect.sharedui.generated.resources.reports
import ischoolconnect.sharedui.generated.resources.school_users
import ischoolconnect.sharedui.generated.resources.ic_launcher
import ischoolconnect.sharedui.generated.resources.schools
import ischoolconnect.sharedui.generated.resources.stat_helpdesk
import ischoolconnect.sharedui.generated.resources.stat_parents
import ischoolconnect.sharedui.generated.resources.stat_school
import ischoolconnect.sharedui.generated.resources.stat_students
import ischoolconnect.sharedui.generated.resources.stat_teacher
import ischoolconnect.sharedui.generated.resources.stat_users
import ischoolconnect.sharedui.generated.resources.teacher
import ischoolconnect.sharedui.generated.resources.user_plus
import ischoolconnect.sharedui.generated.resources.users
import ischoolconnect.sharedui.generated.resources.message
import ischoolconnect.sharedui.generated.resources.subscriptions
import ischoolconnect.sharedui.generated.resources.role_parent
import org.jetbrains.compose.resources.painterResource

internal val HomeBg = AppBackground
internal val HomeSurface = AppSurface
internal val HomeBorder = AppSecondaryBorder
internal val HomeTextPrimary = AppNavy
internal val HomeTextSecondary = AppMuted
internal val HomeTextMuted = Color(0xFF7C86B2)
internal val HomeBlue = AppPrimary
internal val HomeBlueSoft = AppPrimarySoft
/** Selected sidebar / rail item (icon + label). Matches page header blue. */
internal val HomeRailSelected = AppPageHeader
internal val HomeRailSelectedSoft = Color(0xFFE8EEF7)
internal val HomeGreen = AppSuccess
internal val HomeGreenSoft = AppSuccessSoft
internal val HomePurple = AppPurpleText
internal val HomePurpleSoft = AppPurpleSoft
internal val HomeOrange = AppWarning
internal val HomeOrangeSoft = AppWarningSoft
internal val HomeRed = AppDanger
internal val HomeRedSoft = AppDangerSoft

internal data class NavGroup(
    val label: String,
    val items: List<NavItem>
)

internal data class NavItem(
    val id: String,
    val title: String,
    val icon: String,
    val isActive: Boolean = false,
    val isClickable: Boolean = true,
    val children: List<NavItem> = emptyList()
)

internal data class MetricCardData(
    val title: String,
    val value: String,
    val subtitle: String,
    val icon: String,
    val accent: Color,
    val accentSoft: Color,
    val footer: MetricFooter
)

internal sealed interface MetricFooter {
    data class Bullets(val entries: List<Pair<String, Color>>) : MetricFooter
    /** Compact 2-column (or N-column) bullet grid for dense cards like Staff / Tickets. */
    data class BulletGrid(
        val entries: List<Pair<String, Color>>,
        val columns: Int = 2
    ) : MetricFooter
    data class Trend(val value: String, val label: String, val color: Color = HomeGreen) : MetricFooter
    data class Warning(val value: String, val label: String, val color: Color = HomeRed) : MetricFooter
    data class Caption(val text: String, val color: Color = HomeTextSecondary) : MetricFooter
}

internal data class ActivityEntry(
    val title: String,
    val subtitle: String? = null,
    val actorLogin: String? = null,
    val time: String,
    val icon: String,
    val iconTint: Color,
    val iconBg: Color,
    val badge: String? = null,
    val badgeTint: Color? = null,
    val badgeBg: Color? = null
)

internal data class HealthEntry(
    val title: String,
    val value: String,
    val icon: String,
    val iconTint: Color = HomeTextPrimary
)

internal data class HomeDashboardContent(
    val navGroups: List<NavGroup>,
    val metrics: List<MetricCardData>,
    val recentActivities: List<ActivityEntry>,
    val healthEntries: List<HealthEntry>
)

internal data class SchoolAdminDashboardContent(
    val academicYearLabel: String,
    val navGroups: List<NavGroup>,
    val statCards: List<SchoolAdminStatCardData>,
    val notices: List<SchoolAdminFeedItem>,
    val events: List<SchoolAdminFeedItem>
)

internal data class SchoolAdminStatCardData(
    val title: String,
    val value: String,
    val icon: String,
    val accent: Color,
    val accentSoft: Color,
    val breakdown: List<SchoolAdminStatSection>
)

internal data class SchoolAdminStatSection(
    val title: String,
    val value: String
)

internal data class SchoolAdminFeedItem(
    val title: String,
    val subtitle: String,
    val trailingLabel: String,
    val icon: String = "",
    val iconTint: Color = HomeTextPrimary,
    val iconBg: Color = HomeBlueSoft,
    val dateDay: String = "",
    val dateMonth: String = "",
    val dateBg: Color = HomeBlueSoft,
    val dateTint: Color = HomeBlue
)

internal object HomeDefaults {
    internal fun allowedRailIds(roleCode: String): Set<String> {
        val navGroups = if (roleCode == SchoolKeys.V_ROLE_SCHOOL_ADMIN) {
            schoolAdminDashboardContent().navGroups
        } else {
            dashboardContent(roleCode = roleCode).navGroups
        }

        return buildSet {
            add("dashboard")
            navGroups.forEach { group ->
                group.items.forEach { item ->
                    add(item.id)
                    item.children.forEach { child -> add(child.id) }
                }
            }
            // The school-admin sidebar labels this destination separately from
            // the dashboard's legacy "time-table" rail item. Both resolve to
            // the same timetable screen, so allow the real ID to survive reload.
            if (roleCode == SchoolKeys.V_ROLE_SCHOOL_ADMIN) {
                add("time-table-import")
            }
        }
    }

    fun createRolePickerState(): RolePickerUiState {
        return RolePickerUiState(
            isVisible = false,
            title = "Change Role",
            subtitle = "Select a role to continue",
            options = emptyList(),
            selectedOptionId = "",
            rememberSelection = true,
            canDismiss = true,
            isLoading = false,
            errorMessage = "",
            isSubmitting = false
        )
    }

    fun dashboardContent(
        selectedNavId: String = "dashboard",
        roleCode: String = SchoolKeys.V_ROLE_APP_SUPER_ADMIN,
        analytics: DashboardAnalyticsResponse? = null,
        schoolsAnalytics: DashboardSchoolsAnalyticsResponse? = null,
        statistics: DashboardStatisticsResponse? = null,
        recentActivities: RecentActivitiesResponse? = null,
        systemHealth: SystemHealthResponse? = null
    ): HomeDashboardContent {
        val navGroups = if (roleCode == SchoolKeys.V_ROLE_TEACHER) {
            teacherNavGroups(selectedNavId)
        } else if (roleCode == SchoolKeys.V_ROLE_PARENT) {
            parentNavGroups(selectedNavId)
        } else listOf(
            NavGroup(
                label = "PLATFORM",
                items = listOf(
                    NavItem("dashboard", "Dashboard", "dashboard", isActive = selectedNavId == "dashboard"),
                    NavItem("schools", "Schools", "schools", isActive = selectedNavId == "schools"),
                    NavItem("school-users", "School Users", "school_users", isActive = selectedNavId == "school-users"),
                    NavItem("academic-years", "Academic Years", "academic_years", isActive = selectedNavId == "academic-years"),
                    if (roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN) {
                        NavItem("school-config", "School Configuration", "school_config", isActive = selectedNavId == "school-config")
                    } else {
                        null
                    }
                ).filterNotNull()
            ),
            NavGroup(
                label = "OPERATIONS",
                items = listOf(
                    NavItem("it-users", "IT Support Users", "it_users", isActive = selectedNavId == "it-users"),
                    NavItem("help-desk", "Support Queue", "help_desk", isActive = selectedNavId == "help-desk"),
                    NavItem("broadcasts", "Broadcasts", "broadcasts", isActive = selectedNavId == "broadcasts"),
                    NavItem("reports", "Reports", "reports", isActive = selectedNavId == "reports")
                )
            ),
            NavGroup(
                label = "BILLING",
                items = listOf(
                    NavItem("plans", "Plans", "plans", isActive = selectedNavId == "plans"),
                    NavItem("subscriptions", "Subscriptions", "subscriptions", isActive = selectedNavId == "subscriptions"),
                    NavItem("payments", "Payments", "payments", isActive = selectedNavId == "payments")
                )
            ),
            NavGroup(
                label = "SYSTEM",
                items = listOf(
                    NavItem("config", "Config", "config", isActive = selectedNavId == "config"),
                    NavItem("audit-logs", "Audit Logs", "audit_logs", isActive = selectedNavId == "audit-logs"),
                    NavItem("notifications", "Notifications", "notifications", isActive = selectedNavId == "notifications")
                )
            )
        )

        val metrics = buildPlatformMetrics(
            roleCode = roleCode,
            analytics = analytics,
            schoolsAnalytics = schoolsAnalytics,
            statistics = statistics
        )

        val recentActivityEntries = buildRecentActivities(recentActivities)

        val healthEntries = buildHealthEntries(systemHealth)

        return HomeDashboardContent(
            navGroups = navGroups,
            metrics = metrics,
            recentActivities = recentActivityEntries,
            healthEntries = healthEntries
        )
    }

    private fun parentNavGroups(selectedNavId: String): List<NavGroup> = listOf(
        NavGroup(
            label = "",
            items = listOf(
                NavItem(
                    id = "academics",
                    title = "Academics",
                    icon = "book",
                    children = listOf(
                        NavItem("attendance", "Attendance", "calendar", isActive = selectedNavId == "attendance"),
                        NavItem("homework", "Homework", "document", isActive = selectedNavId == "homework"),
                        NavItem("exam-results", "Exam Results", "graduation_cap", isActive = selectedNavId == "exam-results"),
                        NavItem("time-table", "Time Table", "clock", isActive = selectedNavId == "time-table")
                    )
                )
            )
        ),
        NavGroup(
            label = "",
            items = listOf(
                NavItem(
                    id = "communication",
                    title = "Communication",
                    icon = "message",
                    children = listOf(
                        NavItem("notices", "Notices", "megaphone", isActive = selectedNavId == "notices"),
                        NavItem("parent-notes", "Teacher Notes", "document", isActive = selectedNavId == "parent-notes"),
                        NavItem("class-conversations", "Class Conversations", "message", isActive = selectedNavId == "class-conversations"),
                        NavItem("events-news", "Events & News", "calendar", isActive = selectedNavId == "events-news"),
                        NavItem("document-library", "Document Library", "document", isActive = selectedNavId == "document-library")
                    )
                )
            )
        ),
        NavGroup(
            label = "CALENDAR",
            items = listOf(
                NavItem("calendar", "Calendar", "calendar", isActive = selectedNavId == "calendar")
            )
        ),
        NavGroup(
            label = "",
            items = listOf(
                NavItem("analytics-reports", "Reports & Analytics", "reports", isActive = selectedNavId == "analytics-reports"),
                NavItem("help-desk", "Help & Support", "help_desk", isActive = selectedNavId == "help-desk")
            )
        )
    )

    /**
     * Teacher navigation is intentionally UI-only for now. The existing shell
     * still owns navigation, role menus, spacing, typography, and icon styling;
     * feature routes can be connected as those teacher capabilities are staged.
     */
    internal fun teacherNavGroups(
        selectedNavId: String,
        studentTitle: String = "My Students"
    ): List<NavGroup> = listOf(
        NavGroup(
            label = "",
            items = listOf(
                NavItem(
                    id = "academics",
                    title = "Academics",
                    icon = "book",
                    children = listOf(
                        NavItem("students", studentTitle, "users", isActive = selectedNavId == "students"),
                        NavItem("attendance", "Attendance", "calendar", isActive = selectedNavId == "attendance"),
                        NavItem("homework", "Homework", "document", isActive = selectedNavId == "homework"),
                        NavItem(
                            id = "exams",
                            title = "Exams",
                            icon = "graduation_cap",
                            isActive = selectedNavId == "exams" || selectedNavId == "exam-setup"
                        ),
                        NavItem("time-table", "Time Table", "clock", isActive = selectedNavId == "time-table")
                    )
                )
            )
        ),
        NavGroup(
            label = "",
            items = listOf(
                NavItem(
                    id = "communication",
                    title = "Communication",
                    icon = "broadcasts",
                    children = listOf(
                        NavItem("quick-announcements", "Quick Announcements", "megaphone", isActive = selectedNavId == "quick-announcements"),
                        NavItem("notices", "Notices", "megaphone", isActive = selectedNavId == "notices"),
                        NavItem("parent-notes", "Parent Notes", "document", isActive = selectedNavId == "parent-notes"),
                        NavItem("class-conversations", "Class Conversations", "message", isActive = selectedNavId == "class-conversations"),
                        NavItem("events-news", "Events & News", "calendar", isActive = selectedNavId == "events-news"),
                        NavItem("document-library", "Document Library", "document", isActive = selectedNavId == "document-library")
                    )
                )
            )
        ),
        NavGroup(
            label = "",
            items = listOf(
                NavItem("calendar", "Calendar", "calendar", isActive = selectedNavId == "calendar"),
                NavItem("analytics-reports", "Reports & Analytics", "reports", isActive = selectedNavId == "analytics-reports"),
                NavItem("help-desk", "Help & Support", "help_desk", isActive = selectedNavId == "help-desk")
            )
        )
    )

    internal fun buildHealthEntries(systemHealth: SystemHealthResponse?): List<HealthEntry> {
        val services = systemHealth?.services ?: return emptyList()
        val apiStatus = services.api.status.orFallback("Unknown")
        val apiLatency = services.api.responseTimeMs?.let { "$it ms" }.orFallback("n/a")
        val databaseStatus = services.database.status.orFallback("Unknown")
        val pushStatus = services.pushNotifications.status.orFallback("Unknown")
        val smsStatus = services.smsDelivery.status.orFallback("Unknown")
        val uptimeValue = services.serverUptime.humanReadable.orFallback("n/a")
        val backupStatus = services.backupStatus.status.orFallback("Unknown")
        val lastBackup = services.backupStatus.lastBackup.orFallback("n/a").toCompactDateLabel()

        return listOf(
            HealthEntry("API", "$apiStatus | $apiLatency", "health_chart"),
            HealthEntry("Push Notifications", pushStatus, "bell"),
            HealthEntry("SMS Delivery", smsStatus, "health_sms"),
            HealthEntry("Database", databaseStatus, "health_database"),
            HealthEntry("Server Uptime", uptimeValue, "health_server"),
            HealthEntry("Last Backup", "$backupStatus | $lastBackup", "health_backup")
        )
    }

    private fun String?.orFallback(fallback: String): String = if (isNullOrBlank()) fallback else this

    private fun String.toCompactDateLabel(): String {
        val trimmed = trim()
        if (trimmed.isBlank()) return "n/a"
        if (!trimmed.contains('T')) return trimmed
        return formatIsoDateLabel(trimmed)
    }

fun schoolAdminDashboardContent(
    selectedNavId: String = "dashboard",
    academicYearLabel: String = "School Overview",
    statistics: SchoolStatisticsResponse? = null,
    eventsNotices: EventsNoticesAnalyticsResponse? = null
): SchoolAdminDashboardContent {
    val navGroups = listOf(
            NavGroup(
                label = "MAIN",
                items = listOf(
                    NavItem("dashboard", "Dashboard", "home", isActive = selectedNavId == "dashboard"),
                    NavItem("analytics-reports", "Reports & Analytics", "reports", isActive = selectedNavId == "analytics-reports")
                )
            ),
            NavGroup(
                label = "BULK IMPORT",
                items = listOf(
                    NavItem("school-setup", "School Setup", "building", isActive = selectedNavId == "school-setup"),
                    NavItem("student-enrollment", "Student Enrollment", "user_plus", isActive = selectedNavId == "student-enrollment"),
                    NavItem("calendar", "Calendar", "calendar", isActive = selectedNavId == "calendar"),
                    NavItem("time-table", "Time Table", "clock", isActive = selectedNavId == "time-table")
                )
            ),
            NavGroup(
                label = "MANAGE RECORDS",
                items = listOf(
                    NavItem("staff", "Staff", "school_users", isActive = selectedNavId == "staff"),
                    NavItem("classes", "Classes", "book", isActive = selectedNavId == "classes"),
                    NavItem("subjects", "Subjects", "document", isActive = selectedNavId == "subjects"),
                    NavItem("students", "Students", "graduation_cap", isActive = selectedNavId == "students"),
                    NavItem("parents", "Parents", "users", isActive = selectedNavId == "parents"),
                    NavItem("document-library", "Document Library", "document", isActive = selectedNavId == "document-library")
                )
            ),
            NavGroup(
                label = "SUPPORT",
                items = listOf(
                    NavItem("support-center", "Support Center", "help_desk", isActive = selectedNavId == "support-center")
                )
            )
        )

    val statCards = buildSchoolAdminStatCards(statistics)

    val notices = buildSchoolAdminNotices(eventsNotices)
    val events = buildSchoolAdminEvents(eventsNotices)

    return SchoolAdminDashboardContent(
        academicYearLabel = academicYearLabel.ifBlank { "School Overview" },
        navGroups = navGroups,
        statCards = statCards,
        notices = notices,
        events = events
    )
}

private fun buildSchoolAdminNotices(
    response: EventsNoticesAnalyticsResponse?
): List<SchoolAdminFeedItem> {
    val notices = response?.recentNotices.orEmpty()
    if (notices.isEmpty()) return emptyList()
    return notices.mapIndexed { index, notice -> notice.toSchoolAdminFeedItem(index) }
}

private fun buildSchoolAdminEvents(
    response: EventsNoticesAnalyticsResponse?
): List<SchoolAdminFeedItem> {
    val events = response?.upcomingEvents.orEmpty()
    if (events.isEmpty()) return emptyList()
    return events.mapIndexed { index, event -> event.toSchoolAdminFeedItem(index) }
}

private fun RecentNoticeSummary.toSchoolAdminFeedItem(index: Int): SchoolAdminFeedItem {
    val accent = when (priority.trim().uppercase()) {
        "HIGH" -> HomeRed
        "MEDIUM" -> HomeOrange
        "LOW" -> HomeBlue
        else -> HomeBlue
    }
    val softAccent = when (priority.trim().uppercase()) {
        "HIGH" -> HomeRedSoft
        "MEDIUM" -> HomeOrangeSoft
        "LOW" -> HomeBlueSoft
        else -> HomeBlueSoft
    }
    return SchoolAdminFeedItem(
        title = title.ifBlank { "Notice ${index + 1}" },
        subtitle = content.orEmpty().ifBlank { "No notice details available." },
        trailingLabel = createdAt.toCompactTimeStampLabel(),
        icon = when (noticeType.trim().uppercase()) {
            "ALERT" -> "notifications"
            "ANNOUNCEMENT" -> "document"
            else -> "mail"
        },
        iconTint = accent,
        iconBg = softAccent
    )
}

private fun UpcomingEventSummary.toSchoolAdminFeedItem(index: Int): SchoolAdminFeedItem {
    val eventColor = when (eventType.trim().uppercase()) {
        "SPORTS" -> HomeGreen
        "EVENT" -> HomeBlue
        "MEETING" -> HomePurple
        else -> HomeOrange
    }
    val eventSoftColor = when (eventType.trim().uppercase()) {
        "SPORTS" -> HomeGreenSoft
        "EVENT" -> HomeBlueSoft
        "MEETING" -> HomePurpleSoft
        else -> HomeOrangeSoft
    }
    val dateLabel = eventDate.toCompactDatePartsLabel()
    return SchoolAdminFeedItem(
        title = title.ifBlank { "Event ${index + 1}" },
        subtitle = description.orEmpty().ifBlank { "Upcoming school event." },
        trailingLabel = eventDate.toCompactTimeLabel(),
        dateDay = dateLabel.first,
        dateMonth = dateLabel.second,
        dateBg = eventSoftColor,
        dateTint = eventColor
    )
}

private fun String.toCompactDatePartsLabel(): Pair<String, String> {
    val localDateTime = parseDashboardLocalDateTime(this)
    if (localDateTime != null) {
        return localDateTime.day.toString().padStart(2, '0') to shortMonthName(localDateTime.month.ordinal + 1)
    }
    return rawCompactDatePartsLabel(this)
}

private fun String.toCompactTimeLabel(): String {
    val trimmed = trim()
    val localDateTime = parseDashboardLocalDateTime(trimmed)
    val hour = localDateTime?.hour ?: rawCompactTimeParts(trimmed)?.first ?: return "All Day"
    val minute = localDateTime?.minute ?: rawCompactTimeParts(trimmed)?.second ?: 0
    if (hour == 0 && minute == 0) return "All Day"
    val suffix = if (hour >= 12) "PM" else "AM"
    val displayHour = when (val normalized = hour % 12) {
        0 -> 12
        else -> normalized
    }
    return "${displayHour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} $suffix"
}

private fun String.toCompactTimeStampLabel(): String {
    val trimmed = trim()
    if (trimmed.isBlank()) return "Recently"
    val dateLabel = trimmed.toCompactDatePartsLabel()
    val timeLabel = trimmed.toCompactTimeLabel()
    return if (timeLabel == "All Day") {
        "${dateLabel.first} ${dateLabel.second}"
    } else {
        "${dateLabel.first} ${dateLabel.second}, $timeLabel"
    }
}

private fun parseDashboardLocalDateTime(value: String): LocalDateTime? {
    val trimmed = value.trim()
    if (trimmed.length < 10 || !trimmed.contains('T')) return null
    val localTimeZone = TimeZone.currentSystemDefault()
    return runCatching {
        Instant.parse(trimmed).toLocalDateTime(localTimeZone)
    }.getOrElse {
        // The dashboard API may omit the offset. Its server timestamps are UTC.
        runCatching {
            LocalDateTime.parse(trimmed).toInstant(TimeZone.UTC).toLocalDateTime(localTimeZone)
        }.getOrNull()
    }
}

private fun rawCompactDatePartsLabel(value: String): Pair<String, String> {
    val datePart = value.trim().takeIf { it.length >= 10 }?.substring(0, 10).orEmpty()
    val parts = datePart.split("-")
    if (parts.size != 3) return "00" to "UNK"
    val month = parts[1].toIntOrNull() ?: return "00" to "UNK"
    val day = parts[2].toIntOrNull() ?: return "00" to "UNK"
    return day.toString().padStart(2, '0') to shortMonthName(month)
}

private fun rawCompactTimeParts(value: String): Pair<Int, Int>? {
    val timePart = value.trim().substringAfter('T', missingDelimiterValue = "").takeIf { it.isNotBlank() } ?: return null
    val raw = timePart.takeWhile { it.isDigit() || it == ':' }
    val parts = raw.split(":")
    val hour = parts.getOrNull(0)?.toIntOrNull() ?: return null
    val minute = parts.getOrNull(1)?.toIntOrNull() ?: 0
    return hour to minute
}

private fun buildSchoolAdminStatCards(
    statistics: SchoolStatisticsResponse?
): List<SchoolAdminStatCardData> {
    val metrics = statistics?.statistics ?: return emptyList()
    return listOf(
        SchoolAdminStatCardData(
            title = "Staff",
            value = formatMetricCount(metrics.staff.total),
            icon = "school_users",
            accent = HomeBlue,
            accentSoft = HomeBlueSoft,
            breakdown = listOf(
                SchoolAdminStatSection("Teachers", formatMetricCount(metrics.staff.teachers.total)),
                SchoolAdminStatSection("Support Staff", formatMetricCount(metrics.staff.supportStaff.total))
            )
        ),
        SchoolAdminStatCardData(
            title = "Classes",
            value = formatMetricCount(metrics.classes.total),
            icon = "book",
            accent = HomeOrange,
            accentSoft = HomeOrangeSoft,
            breakdown = listOf(
                SchoolAdminStatSection("Active", formatMetricCount(metrics.classes.active)),
                SchoolAdminStatSection("Inactive", formatMetricCount(metrics.classes.inactive))
            )
        ),
        SchoolAdminStatCardData(
            title = "Subjects",
            value = formatMetricCount(metrics.subjects.total),
            icon = "document",
            accent = HomePurple,
            accentSoft = HomePurpleSoft,
            breakdown = listOf(
                SchoolAdminStatSection("Active", formatMetricCount(metrics.subjects.active)),
                SchoolAdminStatSection("Inactive", formatMetricCount(metrics.subjects.inactive))
            )
        ),
        SchoolAdminStatCardData(
            title = "Students",
            value = formatMetricCount(metrics.students.total),
            icon = "graduation_cap",
            accent = HomeGreen,
            accentSoft = HomeGreenSoft,
            breakdown = listOf(
                SchoolAdminStatSection("Active", formatMetricCount(metrics.students.active)),
                SchoolAdminStatSection("Inactive", formatMetricCount(metrics.students.inactive))
            )
        ),
        SchoolAdminStatCardData(
            title = "Parents",
            value = formatMetricCount(metrics.parents.total),
            icon = "users",
            accent = HomeRed,
            accentSoft = HomeRedSoft,
            breakdown = listOf(
                SchoolAdminStatSection("Active", formatMetricCount(metrics.parents.active)),
                SchoolAdminStatSection("Inactive", formatMetricCount(metrics.parents.inactive))
            )
        )
    )
}

private fun buildRecentActivities(
    response: RecentActivitiesResponse?
): List<ActivityEntry> {
    if (response == null) return emptyList()
    return response.activities.map { activity -> activity.toActivityEntry() }
}

private fun RecentActivitySummary.toActivityEntry(): ActivityEntry {
    val actionKey = action.trim().uppercase()
    val actionTint = when (actionKey) {
        "INSERT" -> HomeGreen
        "UPDATE" -> HomeOrange
        "DELETE" -> HomeRed
        else -> HomeBlue
    }
    val actionSoft = when (actionKey) {
        "INSERT" -> HomeGreenSoft
        "UPDATE" -> HomeOrangeSoft
        "DELETE" -> HomeRedSoft
        else -> HomeBlueSoft
    }
    val fallbackTitle = when (actionKey) {
        "INSERT" -> "Record created"
        "UPDATE" -> "Record updated"
        "DELETE" -> "Record deleted"
        else -> "Activity"
    }
    return ActivityEntry(
        title = description.trim().ifBlank { fallbackTitle },
        subtitle = null,
        actorLogin = actorLogin?.trim()?.takeIf { it.isNotBlank() && it != "—" },
        time = formatIsoDateTimeLabel(timestamp),
        icon = when (actionKey) {
            "INSERT" -> "document"
            "UPDATE" -> "edit"
            "DELETE" -> "audit_logs"
            else -> "activity_user"
        },
        iconTint = actionTint,
        iconBg = actionSoft,
        badge = null,
        badgeTint = null,
        badgeBg = null
    )
}

private fun formatIsoDateTimeLabel(value: String): String {
    val trimmed = value.trim()
    if (trimmed.length < 10) return trimmed.ifBlank { "Recently" }
    val datePart = trimmed.substring(0, 10)
    val parts = datePart.split("-")
    if (parts.size != 3) return trimmed.ifBlank { "Recently" }
    val month = parts[1].toIntOrNull() ?: return trimmed.ifBlank { "Recently" }
    val day = parts[2].toIntOrNull() ?: return trimmed.ifBlank { "Recently" }
    val dateLabel = "${day.toString().padStart(2, '0')} ${shortMonthName(month)}"
    val timeLabel = formatIsoClockLabel(trimmed) ?: return dateLabel
    return "$dateLabel $timeLabel"
}

/** Formats `...T14:32:00...` / `... 14:32:00` as `02:32 PM`. */
private fun formatIsoClockLabel(value: String): String? {
    val timeMatch = Regex("""[T\s](\d{2}):(\d{2})(?::\d{2})?""").find(value) ?: return null
    val hour24 = timeMatch.groupValues[1].toIntOrNull() ?: return null
    val minute = timeMatch.groupValues[2].toIntOrNull() ?: return null
    val meridiem = if (hour24 >= 12) "PM" else "AM"
    val hour12 = when {
        hour24 == 0 -> 12
        hour24 > 12 -> hour24 - 12
        else -> hour24
    }
    return "${hour12.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} $meridiem"
}

private fun formatIsoDateLabel(value: String): String {
    val trimmed = value.trim()
    if (trimmed.length < 10) return trimmed.ifBlank { "Recently" }
    val parts = trimmed.substring(0, 10).split("-")
    if (parts.size != 3) return trimmed.ifBlank { "Recently" }
    val month = parts[1].toIntOrNull() ?: return trimmed.ifBlank { "Recently" }
    val day = parts[2].toIntOrNull() ?: return trimmed.ifBlank { "Recently" }
    return "${day.toString().padStart(2, '0')} ${shortMonthName(month)}"
}

private fun shortMonthName(month: Int): String = when (month) {
    1 -> "JAN"
    2 -> "FEB"
    3 -> "MAR"
    4 -> "APR"
    5 -> "MAY"
    6 -> "JUN"
    7 -> "JUL"
    8 -> "AUG"
    9 -> "SEP"
    10 -> "OCT"
    11 -> "NOV"
    12 -> "DEC"
    else -> "UNK"
}

private fun buildPlatformMetrics(
    roleCode: String,
    analytics: DashboardAnalyticsResponse?,
    schoolsAnalytics: DashboardSchoolsAnalyticsResponse?,
    statistics: DashboardStatisticsResponse?
): List<MetricCardData> {
    val schoolMetric = if (roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN) {
        buildSchoolsMetric(schoolsAnalytics)
    } else {
        null
    }

    val baseMetrics = if (statistics == null) {
        analytics.toDashboardMetrics()
    } else {
        val analyticsMetrics = analytics?.metrics
        val stats = statistics.statistics
        val itFromStats = stats.itStaff
        val itFromAnalytics = analyticsMetrics?.itUsers
        val preferStatsIt = itFromStats.active > 0 ||
            itFromStats.total > 0 ||
            itFromAnalytics == null
        val itActive = if (preferStatsIt) itFromStats.active else (itFromAnalytics?.active ?: 0)
        listOf(
            MetricCardData(
                title = "School Staff",
                value = formatMetricCount(stats.staff.active),
                subtitle = ACTIVE_RECORDS_ONLY_NOTE,
                icon = "school_users",
                accent = AdminSummaryMetrics.Staff.accent,
                accentSoft = AdminSummaryMetrics.Staff.soft,
                footer = MetricFooter.BulletGrid(
                    listOf(
                        activeRoleLine("Mgmt", stats.staff.schoolMgmt) to AdminSummaryMetrics.Blue.accent,
                        activeRoleLine("Admins", stats.staff.schoolAdmins) to AdminSummaryMetrics.Purple.accent,
                        activeRoleLine("Teachers", stats.staff.teachers) to AdminSummaryMetrics.Green.accent,
                        activeRoleLine("Support Staff", stats.staff.supportStaffRole) to AdminSummaryMetrics.Orange.accent
                    )
                )
            ),
            MetricCardData(
                title = "Classes",
                value = formatMetricCount(stats.classes.active),
                subtitle = ACTIVE_RECORDS_ONLY_NOTE,
                icon = "book",
                accent = AdminSummaryMetrics.Classes.accent,
                accentSoft = AdminSummaryMetrics.Classes.soft,
                footer = MetricFooter.Bullets(emptyList())
            ),
            MetricCardData(
                title = "Subjects",
                value = formatMetricCount(stats.subjects.active),
                subtitle = ACTIVE_RECORDS_ONLY_NOTE,
                icon = "document",
                accent = AdminSummaryMetrics.Subjects.accent,
                accentSoft = AdminSummaryMetrics.Subjects.soft,
                footer = MetricFooter.Bullets(emptyList())
            ),
            MetricCardData(
                title = "Students",
                value = formatMetricCount(stats.students.active),
                subtitle = ACTIVE_RECORDS_ONLY_NOTE,
                icon = "graduation_cap",
                accent = AdminSummaryMetrics.Students.accent,
                accentSoft = AdminSummaryMetrics.Students.soft,
                footer = MetricFooter.Bullets(
                    listOf(
                        "${formatMetricCount(analyticsMetrics?.students?.boys ?: 0)} Boys" to AdminSummaryMetrics.Blue.accent,
                        "${formatMetricCount(analyticsMetrics?.students?.girls ?: 0)} Girls" to AdminSummaryMetrics.Pink.accent
                    )
                )
            ),
            MetricCardData(
                title = "Parents",
                value = formatMetricCount(stats.parents.active),
                subtitle = ACTIVE_RECORDS_ONLY_NOTE,
                icon = "users",
                accent = AdminSummaryMetrics.Parents.accent,
                accentSoft = AdminSummaryMetrics.Parents.soft,
                footer = MetricFooter.Bullets(
                    listOf(
                        "${formatMetricCount(analyticsMetrics?.parents?.primaryContacts ?: 0)} Primary" to AdminSummaryMetrics.Green.accent,
                        "${formatMetricCount(analyticsMetrics?.parents?.secondaryContacts ?: 0)} Secondary" to AdminSummaryMetrics.Orange.accent
                    )
                )
            ),
            MetricCardData(
                title = "IT Users",
                value = formatMetricCount(itActive),
                subtitle = ACTIVE_RECORDS_ONLY_NOTE,
                icon = "it_users",
                accent = AdminSummaryMetrics.ItUsers.accent,
                accentSoft = AdminSummaryMetrics.ItUsers.soft,
                footer = MetricFooter.Bullets(emptyList())
            ),
            MetricCardData(
                title = "Support Tickets",
                value = formatMetricCount(
                    stats.supportTickets.open + stats.supportTickets.inProgress
                ),
                subtitle = "Only Open or In Progress",
                icon = "stat_helpdesk",
                accent = AdminSummaryMetrics.StatusInProgress.accent,
                accentSoft = AdminSummaryMetrics.StatusInProgress.soft,
                footer = MetricFooter.BulletGrid(
                    listOf(
                        "${formatMetricCount(stats.supportTickets.open)} Open" to AdminSummaryMetrics.StatusOpen.accent,
                        "${formatMetricCount(stats.supportTickets.inProgress)} In Progress" to AdminSummaryMetrics.StatusInProgress.accent
                    )
                )
            )
        )
    }

    return listOfNotNull(schoolMetric) + baseMetrics
}

private fun buildSchoolsMetric(
    schoolsAnalytics: DashboardSchoolsAnalyticsResponse?
): MetricCardData? {
    val metrics = schoolsAnalytics?.metrics ?: return null
    return MetricCardData(
        title = "Total Schools",
        value = formatMetricCount(metrics.activeSchools),
        subtitle = ACTIVE_RECORDS_ONLY_NOTE,
        icon = "stat_school",
        accent = AdminSummaryMetrics.Schools.accent,
        accentSoft = AdminSummaryMetrics.Schools.soft,
        footer = MetricFooter.Bullets(emptyList())
    )
}

private fun DashboardAnalyticsResponse?.toDashboardMetrics(): List<MetricCardData> {
    val staff = this?.metrics?.staff
    val students = this?.metrics?.students
    val parents = this?.metrics?.parents
    val itUsers = this?.metrics?.itUsers

    if (this == null) return emptyList()

    return listOf(
        MetricCardData(
            title = "School Staff",
            value = formatMetricCount(
                (staff?.totalTeachers ?: 0) + (staff?.totalSupportStaff ?: 0)
            ),
            subtitle = ACTIVE_RECORDS_ONLY_NOTE,
            icon = "school_users",
            accent = AdminSummaryMetrics.Staff.accent,
            accentSoft = AdminSummaryMetrics.Staff.soft,
            footer = MetricFooter.BulletGrid(
                listOf(
                    "${formatMetricCount(staff?.totalTeachers ?: 0)} Teachers" to AdminSummaryMetrics.Green.accent,
                    "${formatMetricCount(staff?.totalSupportStaff ?: 0)} Support Staff" to AdminSummaryMetrics.Orange.accent
                )
            )
        ),
        MetricCardData(
            title = "Students",
            value = formatMetricCount(students?.total ?: 0),
            subtitle = ACTIVE_RECORDS_ONLY_NOTE,
            icon = "graduation_cap",
            accent = AdminSummaryMetrics.Students.accent,
            accentSoft = AdminSummaryMetrics.Students.soft,
            footer = MetricFooter.Bullets(
                listOf(
                    "${formatMetricCount(students?.boys ?: 0)} Boys" to AdminSummaryMetrics.Blue.accent,
                    "${formatMetricCount(students?.girls ?: 0)} Girls" to AdminSummaryMetrics.Pink.accent
                )
            )
        ),
        MetricCardData(
            title = "Parents",
            value = formatMetricCount(parents?.total ?: 0),
            subtitle = ACTIVE_RECORDS_ONLY_NOTE,
            icon = "users",
            accent = AdminSummaryMetrics.Parents.accent,
            accentSoft = AdminSummaryMetrics.Parents.soft,
            footer = MetricFooter.Bullets(
                listOf(
                    "${formatMetricCount(parents?.primaryContacts ?: 0)} Primary" to AdminSummaryMetrics.Green.accent,
                    "${formatMetricCount(parents?.secondaryContacts ?: 0)} Secondary" to AdminSummaryMetrics.Orange.accent
                )
            )
        ),
        MetricCardData(
            title = "IT Users",
            value = formatMetricCount(itUsers?.active ?: 0),
            subtitle = ACTIVE_RECORDS_ONLY_NOTE,
            icon = "it_users",
            accent = AdminSummaryMetrics.ItUsers.accent,
            accentSoft = AdminSummaryMetrics.ItUsers.soft,
            footer = MetricFooter.Bullets(emptyList())
        )
    )
}

}

private fun formatMetricCount(value: Int): String {
    val raw = value.toString()
    if (raw.length <= 3) return raw
    return raw.reversed().chunked(3).joinToString(",").reversed()
}

private const val ACTIVE_RECORDS_ONLY_NOTE = "Only active records"

private fun activeRoleLine(label: String, metrics: DashboardStatisticsCountMetrics): String {
    return "${formatMetricCount(metrics.active)} $label"
}

@Composable
internal fun DashboardSurface(
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    Card(
        modifier = modifier,
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = HomeSurface),
        border = BorderStroke(1.dp, HomeBorder),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp)
    ) {
        content()
    }
}

@Composable
internal fun SidebarBrand(
    compact: Boolean
) {
    if (compact) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 10.dp, vertical = 6.dp)
                .clip(RoundedCornerShape(22.dp))
                .background(HomeBlueSoft),
            contentAlignment = Alignment.Center
        ) {
            androidx.compose.foundation.Image(
                painter = painterResource(Res.drawable.ic_launcher),
                contentDescription = "iConnect.School",
                modifier = Modifier.size(72.dp),
                contentScale = ContentScale.Fit
            )
        }
    } else {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 14.dp, vertical = 6.dp),
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            androidx.compose.foundation.Image(
                painter = painterResource(Res.drawable.brand_header_proper),
                contentDescription = "iConnect.School",
                modifier = Modifier.width(220.dp),
                contentScale = ContentScale.Fit
            )
        }
    }
}

@Composable
internal fun SidebarGroup(
    group: NavGroup,
    compact: Boolean,
    onNavSelected: (String) -> Unit
) {
    Column(verticalArrangement = Arrangement.spacedBy(if (compact) 8.dp else 10.dp)) {
        if (!compact) {
            Text(
                text = group.label,
                color = HomeTextSecondary,
                style = MaterialTheme.typography.labelSmall,
                fontWeight = FontWeight.SemiBold
            )
        }
        Column(verticalArrangement = Arrangement.spacedBy(if (compact) 4.dp else 6.dp)) {
            group.items.forEach { item ->
                SidebarNavItem(
                    item = item,
                    compact = compact,
                    onClick = { if (item.isClickable) onNavSelected(item.id) }
                )
            }
        }
    }
}

@Composable
internal fun RailTooltip(
    label: String,
    enabled: Boolean,
    content: @Composable () -> Unit
) {
    if (enabled) {
        TooltipBox(
            positionProvider = TooltipDefaults.rememberTooltipPositionProvider(
                positioning = TooltipAnchorPosition.Right,
                spacingBetweenTooltipAndAnchor = 10.dp
            ),
            tooltip = {
                PlainTooltip(
                    modifier = Modifier
                        .widthIn(max = 240.dp)
                        .border(1.dp, AppBorder, RoundedCornerShape(10.dp)),
                    maxWidth = 240.dp,
                    shape = RoundedCornerShape(10.dp),
                    contentColor = AppNavy,
                    containerColor = AppSurface,
                    shadowElevation = 6.dp
                ) {
                    Text(
                        text = label,
                        modifier = Modifier.padding(horizontal = 4.dp, vertical = 1.dp),
                        style = MaterialTheme.typography.bodySmall,
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            },
            state = rememberTooltipState(),
            content = content
        )
    } else {
        content()
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
internal fun SidebarNavItem(
    item: NavItem,
    compact: Boolean,
    onClick: () -> Unit
) {
    val background = if (item.isActive) HomeRailSelectedSoft else Color.Transparent
    val contentColor = if (item.isActive) HomeRailSelected else HomeTextPrimary
    RailTooltip(label = item.title, enabled = compact) {
        Row(
            modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(background, RoundedCornerShape(12.dp))
            .then(
                if (item.isClickable) {
                    Modifier.clickable(onClick = onClick)
                } else {
                    Modifier
                }
            )
            .padding(horizontal = if (compact) 0.dp else 12.dp, vertical = if (compact) 10.dp else 12.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(12.dp)
        ) {
        Icon(
            painter = homeIconPainter(item.icon),
            contentDescription = null,
            tint = contentColor,
            modifier = Modifier.size(if (compact) 22.dp else 20.dp)
        )
        AnimatedVisibility(
            visible = !compact,
            enter = fadeIn() + expandHorizontally(expandFrom = Alignment.Start),
            exit = fadeOut() + shrinkHorizontally(shrinkTowards = Alignment.Start)
        ) {
            Text(
                text = item.title,
                style = MaterialTheme.typography.bodyLarge,
                fontFamily = interSemiBold(),
                color = contentColor,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        }
    }
}

@Composable
internal fun HeaderMenuButton(
    expanded: Boolean,
    onToggle: () -> Unit
) {
    IconButton(onClick = onToggle) {
        Icon(
            painter = homeIconPainter("chevron_down"),
            contentDescription = if (expanded) "Close menu" else "Open menu",
            tint = HomeTextPrimary
        )
    }
}

@Composable
internal fun HomeFooterBar(
    copyrightText: String,
    versionLabel: String,
    modifier: Modifier = Modifier,
    textColor: Color = HomeTextSecondary,
    accentColor: Color = HomeBlue,
    linkLabels: List<String> = listOf("Privacy Policy", "Terms of Use", "Help Center")
) {
    Row(
        modifier = modifier.padding(top = 4.dp, bottom = 6.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = copyrightText,
            style = MaterialTheme.typography.bodyMedium,
            color = textColor
        )
        Row(horizontalArrangement = Arrangement.spacedBy(18.dp), verticalAlignment = Alignment.CenterVertically) {
            linkLabels.forEach { label ->
                Text(
                    text = label,
                    style = MaterialTheme.typography.bodyMedium,
                    color = accentColor
                )
            }
            Text(
                text = versionLabel,
                style = MaterialTheme.typography.bodyMedium,
                color = textColor
            )
        }
    }
}

@Composable
internal fun RoleBadge(label: String) {
    Box(
        modifier = Modifier
            .widthIn(max = 220.dp)
            .background(HomeBlueSoft, RoundedCornerShape(10.dp))
            .padding(horizontal = 10.dp, vertical = 6.dp)
    ) {
        Text(
            text = label,
            color = HomeBlue,
            style = MaterialTheme.typography.labelSmall,
            fontWeight = FontWeight.SemiBold,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
internal fun DropdownAccountMenu(
    expanded: Boolean,
    onDismiss: () -> Unit,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit
) {
    AppDropdownMenu(
        expanded = expanded,
        onDismissRequest = onDismiss,
        offset = DpOffset(0.dp, 8.dp),
        shape = RoundedCornerShape(16.dp),
        containerColor = HomeSurface,
        tonalElevation = 6.dp,
        shadowElevation = 20.dp,
        modifier = Modifier
            .width(206.dp)
            .border(1.dp, HomeBorder, RoundedCornerShape(16.dp))
    ) {
        DropdownMenuItem(
            text = { Text("Change Role", fontFamily = interSemiBold(), color = HomeTextPrimary) },
            leadingIcon = {
                Icon(
                    painter = homeIconPainter("change_role"),
                    contentDescription = null,
                    tint = HomeTextPrimary,
                    modifier = Modifier.size(20.dp)
                )
            },
            onClick = {
                onDismiss()
                onChangeRole()
            }
        )
        DropdownMenuItem(
            text = { Text("Sign Out", fontFamily = interSemiBold(), color = HomeTextPrimary) },
            leadingIcon = {
                Icon(
                    painter = homeIconPainter("logout"),
                    contentDescription = null,
                    tint = HomeTextPrimary,
                    modifier = Modifier.size(20.dp)
                )
            },
            onClick = {
                onDismiss()
                onLogout()
            }
        )
    }
}

@Composable
internal fun AvatarChip(
    initials: String,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .background(HomeBlue, CircleShape),
        contentAlignment = Alignment.Center
    ) {
        Text(
            text = initials,
            color = Color.White,
            style = MaterialTheme.typography.titleMedium,
            fontFamily = interBold(),
            fontWeight = FontWeight.Bold
        )
    }
}

@Composable
internal fun SmallStatDot(color: Color, label: String) {
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        Box(
            modifier = Modifier
                .size(8.dp)
                .background(color, CircleShape)
        )
        Text(
            text = label,
            style = MaterialTheme.typography.bodyMedium,
            color = HomeTextSecondary,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
internal fun homeIconPainter(iconKey: String): Painter = when (iconKey) {
    "dashboard" -> painterResource(Res.drawable.dashboard)
    "home" -> painterResource(Res.drawable.home)
    "schools" -> painterResource(Res.drawable.schools)
    "building_school" -> painterResource(Res.drawable.building_school)
    "school_config" -> painterResource(Res.drawable.school_config)
    "building" -> painterResource(Res.drawable.building)
    "folder" -> painterResource(Res.drawable.folder)
    "school_users" -> painterResource(Res.drawable.school_users)
    "academic_years" -> painterResource(Res.drawable.academic_years)
    "it_users" -> painterResource(Res.drawable.it_users)
    "help_desk" -> painterResource(Res.drawable.help_desk)
    "broadcasts" -> painterResource(Res.drawable.broadcasts)
    "reports" -> painterResource(Res.drawable.reports)
    "plans" -> painterResource(Res.drawable.plans)
    "subscriptions" -> painterResource(Res.drawable.subscriptions)
    "payments" -> painterResource(Res.drawable.payments)
    "config" -> painterResource(Res.drawable.config)
    "audit_logs" -> painterResource(Res.drawable.audit_logs)
    "notifications" -> painterResource(Res.drawable.notifications)
    "ic_launcher" -> painterResource(Res.drawable.ic_launcher)
    "stat_school" -> painterResource(Res.drawable.stat_school)
    "stat_users" -> painterResource(Res.drawable.stat_users)
    "stat_teacher" -> painterResource(Res.drawable.stat_teacher)
    "stat_students" -> painterResource(Res.drawable.stat_students)
    "stat_parents" -> painterResource(Res.drawable.stat_parents)
    "stat_helpdesk" -> painterResource(Res.drawable.stat_helpdesk)
    "activity_new_school" -> painterResource(Res.drawable.activity_new_school)
    "activity_user" -> painterResource(Res.drawable.activity_user)
    "activity_calendar" -> painterResource(Res.drawable.activity_calendar)
    "activity_ticket" -> painterResource(Res.drawable.activity_ticket)
    "activity_payment" -> painterResource(Res.drawable.activity_payment)
    "calendar" -> painterResource(Res.drawable.calendar)
    "clock" -> painterResource(Res.drawable.clock)
    "book" -> painterResource(Res.drawable.book)
    "open_book" -> painterResource(Res.drawable.open_book)
    "user_plus" -> painterResource(Res.drawable.user_plus)
    "users" -> painterResource(Res.drawable.users)
    "graduation_cap" -> painterResource(Res.drawable.graduation_cap)
    "cloud_upload" -> painterResource(Res.drawable.cloud_upload)
    "document" -> painterResource(Res.drawable.document)
    "message" -> painterResource(Res.drawable.message)
    "megaphone" -> painterResource(Res.drawable.megaphone)
    "mail" -> painterResource(Res.drawable.mail)
    "phone" -> painterResource(Res.drawable.phone)
    "arrow_left" -> painterResource(Res.drawable.arrow_left)
    "arrow_right" -> painterResource(Res.drawable.arrow_right)
    "role_parent" -> painterResource(Res.drawable.role_parent)
    "teacher" -> painterResource(Res.drawable.teacher)
    "health_chart" -> painterResource(Res.drawable.health_chart)
    "bell" -> painterResource(Res.drawable.bell)
    "blood_drop" -> painterResource(Res.drawable.blood_drop)
    "health_sms" -> painterResource(Res.drawable.health_sms)
    "health_email" -> painterResource(Res.drawable.health_email)
    "health_database" -> painterResource(Res.drawable.health_database)
    "health_server" -> painterResource(Res.drawable.health_server)
    "health_backup" -> painterResource(Res.drawable.health_backup)
    "change_role" -> painterResource(Res.drawable.ic_rotate_right)
    "logout" -> painterResource(Res.drawable.logout)
    "edit" -> painterResource(Res.drawable.edit)
    "chevron_down" -> painterResource(Res.drawable.chevron_down)
    "chevron_up" -> painterResource(Res.drawable.chevron_up)
    "chevron_left" -> painterResource(Res.drawable.chevron_left)
    "chevron_right" -> painterResource(Res.drawable.chevron_right)
    else -> painterResource(Res.drawable.dashboard)
}
